import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCw = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.1666 3.33331V8.33332M19.1666 8.33332H14.1666M19.1666 8.33332L15.3 4.69998C14.4044 3.80391 13.2963 3.14932 12.0793 2.79729C10.8623 2.44527 9.5759 2.40727 8.34022 2.68686C7.10453 2.96645 5.95981 3.55451 5.01287 4.39616C4.06592 5.23782 3.34762 6.30564 2.92498 7.49998M0.833313 16.6666V11.6666M0.833313 11.6666H5.83331M0.833313 11.6666L4.69998 15.3C5.5956 16.1961 6.70362 16.8506 7.92065 17.2027C9.13768 17.5547 10.4241 17.5927 11.6597 17.3131C12.8954 17.0335 14.0401 16.4455 14.9871 15.6038C15.934 14.7621 16.6523 13.6943 17.075 12.5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefreshCw;
